module.exports = __webpack_public_path__ + "img/jingan.d0289dc0.png";